"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var beaver_logger_1 = require("beaver-logger");
function beaverLogger() {
    var clientLogger = beaver_logger_1.Logger({
        url: "/myaccount/profile/api/log",
        logLevel: "info",
        flushInterval: 500,
    });
    return clientLogger;
}
exports.default = beaverLogger;
